import { DRAWER_KEY } from './drawer'

export const FAQ_REDIRECTS_KEYS = {
  GET_INVOICES: 'GET_INVOICES',
  GET_FAQ_EMBEDDING: 'GET_FAQ_EMBEDDING',
  GET_SUPPORT: 'GET_SUPPORT',
}

export const FAQ_REDIRECT_DESTINATION = {
  [FAQ_REDIRECTS_KEYS.GET_FAQ_EMBEDDING]: DRAWER_KEY.FAQ,
  [FAQ_REDIRECTS_KEYS.GET_INVOICES]: DRAWER_KEY.INVOICES,
  [FAQ_REDIRECTS_KEYS.GET_SUPPORT]: DRAWER_KEY.AI_SUPPORT,
}
